import * as React from 'react';
import { Toolbar, IconButton, Slide, Box, Drawer, List, Divider, AppBar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { AppContext, NavLink } from '../../model';
import { useState } from 'react';
import { NavItemList, NavMenuBack, NavMenuItem } from './nav-menu-item';

export interface NavProps {
  context?: AppContext;
  links?: NavLink[];
  onLoading?: (loading: boolean) => void;
}

export function NavMenu(props: NavProps) {
  const { context } = props;
  const [sheetOpen, setSheetOpen] = useState(false);

  const [menuItems] = useState(props.links || []);

  const [currentMenu, setCurrentMenu] = useState({
    menuItems: menuItems || [],
    backLabel: 'Main Menu'
  } as NavItemList);

  const [menuLevel, setMenuLevel] = useState(0);
  const [forward, setForward] = useState(true);
  const [appear, setAppear] = useState(false);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    if (!open) {
      if (props.onLoading) {
        props.onLoading(false);
      }

      setAppear(false);
    }

    setSheetOpen(open);
  };

  const menuItemClick = (menuItem: any, previous: any) => {
    if (menuItem.path && (!menuItem.children || menuItem.children.length == 0)) {
      if (props.onLoading) {
        props.onLoading(true);
      }

      setSheetOpen(false);

      window.location.href = menuItem.path;
    } else if (menuItem && menuItem.children && menuItem.children.length > 0) {
      setCurrentMenu({ backLabel: menuItem.text, parentItems: previous, menuItems: menuItem.children });
      setMenuLevel(menuLevel + 1);
      setForward(true);
      setAppear(true);
    } else if (previous && previous.parentItems) {
      setCurrentMenu(previous.parentItems);
      setMenuLevel(menuLevel - 1);
      setForward(menuLevel == 0);
      setAppear(true);
    }
  };

  const backItemClick = (_menuItem: any, previous: any) => {
    if (previous && previous.parentItems) {
      setCurrentMenu(previous.parentItems);
      setMenuLevel(menuLevel - 1);
      setForward(menuLevel == 0);
      setAppear(true);
    }
  };

  const list = () => (
    <Box
      overflow="hidden"
      padding={0}
      sx={{ width: { xs: '100%', sm: '400px' } }}
      role="presentation"
      onKeyDown={toggleDrawer(false)}
    >
      <AppBar color="primary" position="relative" elevation={0}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="close menu" onClick={toggleDrawer(false)} sx={{ mr: 2 }}>
            <CloseIcon />
          </IconButton>
          {context && context.user?.firstName && (
            <Typography noWrap component="div" color="inherit">
              {`Hi, ${context.user?.firstName}`}
            </Typography>
          )}
        </Toolbar>
      </AppBar>
      <Divider />
      <Slide key={menuLevel} direction={forward ? 'left' : 'right'} in={true} appear={appear}>
        <List sx={{ padding: 0 }}>
          {currentMenu.parentItems && (
            <>
              <NavMenuBack
                item={{
                  id: 'back',
                  text: currentMenu.parentItems.backLabel ? currentMenu.parentItems.backLabel : 'Go Back'
                }}
                previous={currentMenu}
                onClick={backItemClick}
              />
              <Divider />
            </>
          )}
          <Box maxHeight="87vh" padding={0} paddingBottom={10} textOverflow="ellipsis" overflow="auto">
            {currentMenu.menuItems.map((item) => (
              <NavMenuItem key={item.id} item={item} onClick={menuItemClick} previous={currentMenu} />
            ))}
          </Box>
        </List>
      </Slide>
    </Box>
  );

  return (
    <div>
      <IconButton edge="start" onClick={toggleDrawer(true)} color="inherit" aria-label="open menu" sx={{ mr: 2 }}>
        <MenuIcon />
      </IconButton>
      <Drawer
        PaperProps={{ sx: { width: { xs: '100%', sm: 'initial' } } }}
        variant="temporary"
        ModalProps={{
          keepMounted: true
        }}
        anchor="left"
        open={sheetOpen}
        onClose={toggleDrawer(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}
